'use client'

import { useCallback } from 'react'

import {
  AdKind,
  AdPlatform,
  clickAdEvent,
  ClickAdEventTarget,
  VanPlacementConfigModel,
} from '@marketplace-web/ads/ads-data'
import { useTracking } from '@marketplace-web/observability/event-tracker-data'
import { useFeatureSwitch } from '@marketplace-web/feature-flags/feature-switches-data'

const useClickAdEventTracking = () => {
  const { track } = useTracking()
  const isClickAdTrackingEnabled = useFeatureSwitch('web_van_offer_click_ad_tracking')

  const trackClickAdEvent = useCallback(
    (placement: VanPlacementConfigModel | null, target: ClickAdEventTarget) => {
      if (!placement || !isClickAdTrackingEnabled) return

      const { placementId, platform, countryCode, kind, id, correlationId, creative } = placement

      track(
        clickAdEvent({
          placementId,
          target,
          isMobileWeb: platform === AdPlatform.Mobile,
          countryCode,
          creativeId: kind === AdKind.Van ? creative?.id : undefined,
          campaignId: id ?? undefined,
          correlationId,
        }),
      )
    },
    [track, isClickAdTrackingEnabled],
  )

  return { trackClickAdEvent }
}

export default useClickAdEventTracking
